import Cookie from 'js-cookie';
import { createEventSender, EventSender } from '@spotify-internal/event-sender';
import {
  createApplicationContext,
  createCorrelationIdContext,
  createUserAgentContext,
} from '@spotify-internal/event-sender/es5/contexts';
import { getTransportInstance } from 'services/websiteTransport';

export type { EventData } from '@spotify-internal/event-sender';

// EventSender does not export directly the send options
export type EventSenderLogOptions = Parameters<EventSender['send']>[1];

let eventSender: EventSender;

export const getEventSender = async () => {
  if (!eventSender) {
    const transport = (await getTransportInstance()) as any;
    eventSender = createEventSender({
      transport,
      context: [
        createCorrelationIdContext(Cookie.get('sp_usid') ?? 'unknown'),
        createUserAgentContext(window?.navigator?.userAgent ?? 'unknown'),
        createApplicationContext({
          version: process.env.APPLICATION_VERSION ?? 'dev',
        }),
      ],
    });
  }
  return eventSender;
};
